import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[scipSpacesAsIs]'
})
export class SpacesAsIsDirective implements OnInit {
  @Input() customWhitespace = 'pre';

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.el.nativeElement.style.setProperty('white-space', this.customWhitespace);
  }
}
